import { SkeletonButton, SkeletonText } from '@dev-spendesk/grapes';
import React from 'react';

export const AssignControlRuleLoader = () => (
  <div className="flex flex-col gap-8">
    <SkeletonText width="80%" size="xl" />
    <SkeletonText size="l" />
    <SkeletonText className="mt-24" width="20%" size="l" />
    <SkeletonText size="xxl" />
    <div className="mt-24 flex gap-8">
      <SkeletonButton width="20%" />
      <SkeletonButton width="25%" />
    </div>
  </div>
);
